import { Search, Building2, ShoppingCart, Workflow } from "lucide-react";
import { useEffect, useState } from "react";
import { TaxRecord } from "@components/pages/DataTable";

interface SearchBarProps {
  onSearchServico: (query: string) => void;
  onSearchComercio: (query: string, type: SearchType) => void;
  setSearchResults: (results: TaxRecord[] | null) => void;
  setType: (query: SearchType) => void;
  isLoading?: boolean;
}
type SearchType = "servico" | "comercio" | "outras";

export const SearchBar = ({
  onSearchServico,
  onSearchComercio,
  setSearchResults,
  isLoading,
  setType,
}: SearchBarProps) => {
  const [query, setQuery] = useState("");
  const [searchType, setSearchType] = useState<SearchType>("servico");

  useEffect(() => {
    if (searchType === "outras") {
      setType(searchType);
      onSearchComercio("", searchType);
    }
  }, [searchType]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setType(searchType);
    if (query.trim()) {
      if (searchType === "servico") {
        onSearchServico(query.trim());
      } else if (searchType === "comercio") {
        onSearchComercio(query.trim(), searchType);
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      {/* Toggle buttons for search type */}
      <div className="flex justify-center gap-2 mb-4">
        <button
          type="button"
          onClick={() => {
            setSearchType("servico");
            // setSearchResults([]);
          }}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 border-1 ${
            searchType === "servico"
              ? "bg-primary-tail text-primary-tail-foreground border-primary-tail shadow-glow"
              : "bg-card text-muted-foreground border-1 border-border-tail hover:border-primary-tail/50 hover:text-foreground"
          }`}
        >
          <Building2 className="w-4 h-4" />
          Serviço
        </button>
        <button
          type="button"
          onClick={() => {
            setSearchType("comercio");
            // setSearchResults([]);
          }}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 border-1 ${
            searchType === "comercio"
              ? "bg-primary-tail text-primary-tail-foreground border-primary-tail shadow-glow"
              : "bg-card text-muted-foreground border-1 border-border-tail hover:border-primary-tail/50 hover:text-foreground"
          }`}
        >
          <ShoppingCart className="w-4 h-4" />
          Comércio
        </button>
        <button
          type="button"
          onClick={() => setSearchType("outras")}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200 border-1 ${
            searchType === "outras"
              ? "bg-primary-tail text-primary-tail-foreground border-primary-tail shadow-glow"
              : "bg-card text-muted-foreground border-1 border-border-tail hover:border-primary-tail/50 hover:text-foreground"
          }`}
        >
          <Workflow className="w-4 h-4" />
          Outras Operações
        </button>
      </div>
      <div className="relative group">
        <div className="absolute inset-0 bg-primary-tail/20 rounded-xl blur-xl opacity-0 group-focus-within:opacity-100 transition-opacity duration-500" />
        <div className="relative flex items-center bg-card border-1 border-border-tail rounded-xl overflow-hidden transition-all duration-300 group-focus-within:border-primary-tail/50 group-focus-within:shadow-glow">
          <div className="pl-5 text-muted-foreground">
            <Search className="w-5 h-5" />
          </div>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={`Ex: ${
              searchType === "servico"
                ? "01.07 ou Serviços de suporte em tecnologia da informação..."
                : "10.06 ou Arroz, Sementes..."
            } `}
            className="input-base"
            disabled={isLoading || searchType === "outras"}
          />
          <button
            type="submit"
            disabled={isLoading || !query.trim()}
            className="btn-primary-tail"
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-primary-tail-foreground/30 border-t-primary-foreground rounded-full animate-spin" />
                Buscando
              </span>
            ) : (
              "Buscar"
            )}
          </button>
        </div>
      </div>
    </form>
  );
};
